<template>
  <Button :type="type" @click="openDemoForm">{{ title }}</Button>
</template>
<script>
  export default {
    props: {
      title: { type: String, required: true },
      type: { type: String, default: 'primary' },
      eventType: { type: String, enum: ['demo', 'introductory-call'] },
      isMobile: Boolean,
    },
    methods: {
      openDemoForm() {
        // window._elev.openModule('2');
        const vm = this;
        const demoUrl = `https://calendly.com/vue-finance/${vm.eventType}`;
        if (vm.isMobile) {
          window.open(demoUrl);
        } else {
          window.Calendly.showPopupWidget(demoUrl);
        }
      },
    },
  };
</script>
<style lang="css" scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/ScheduleButton.vue